import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Landing from './pages/Landing';
import Login from './pages/Login';
import AdminDashboard from './pages/admin/Dashboard';
import Students from './pages/admin/Students';
import Projects from './pages/admin/Projects';
import ProjectDetail from './pages/admin/ProjectDetail';
import Revenue from './pages/admin/Revenue';
import Leads from './pages/admin/Leads';
import StudentDashboard from './pages/student/Dashboard';
import StudentProjects from './pages/student/Projects';
import StudentProjectDetail from './pages/student/ProjectDetail';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <div className="min-h-screen bg-gray-50">
            <Toaster position="top-right" />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              
              <Route path="/admin" element={
                <ProtectedRoute role="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/students" element={
                <ProtectedRoute role="admin">
                  <Students />
                </ProtectedRoute>
              } />
              <Route path="/admin/projects" element={
                <ProtectedRoute role="admin">
                  <Projects />
                </ProtectedRoute>
              } />
              <Route path="/admin/projects/:id" element={
                <ProtectedRoute role="admin">
                  <ProjectDetail />
                </ProtectedRoute>
              } />
              <Route path="/admin/revenue" element={
                <ProtectedRoute role="admin">
                  <Revenue />
                </ProtectedRoute>
              } />
              <Route path="/admin/leads" element={
                <ProtectedRoute role="admin">
                  <Leads />
                </ProtectedRoute>
              } />
              
              <Route path="/student" element={
                <ProtectedRoute role="student">
                  <StudentDashboard />
                </ProtectedRoute>
              } />
              <Route path="/student/projects" element={
                <ProtectedRoute role="student">
                  <StudentProjects />
                </ProtectedRoute>
              } />
              <Route path="/student/projects/:id" element={
                <ProtectedRoute role="student">
                  <StudentProjectDetail />
                </ProtectedRoute>
              } />

              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;